import React, { useState, useContext } from 'react';
import { Modal, Link, TextField } from '@shopify/polaris'
import { Spinner, EditModal } from '@thinkwell/react.polaris'
import { FormProvider } from '@thinkwell/react.common'
import { HostContext } from '../../contexts/Host'
import { ShopContext } from '../../contexts/Shop'
import PasswordForm from '../../PasswordForm'

export default function LoginAsParentModal(props) {
  const [active, setActive] = useState(false)
  const [loading, setLoading] = useState(false)
  const host = useContext(HostContext)
  const shop_name = useContext(ShopContext)

  const handleChange = () => { setLoading(true); setActive(!active); }

  const activator = <Link onClick={handleChange}>{props.linkTitle}</Link>;

  return (<FormProvider><EditModal
    setSavingRef={props.setSavingRef}
    onSave={props.onSave}
    url={`${host}/accounts/enrollments/login_as_parent?shop_name=${shop_name}&enrollment_id=${props.enrollment.id}`}
    saveText="Login"
    title="Login As Parent">
    <TextField
      disabled
      label="Parent"
      value={`${props.enrollment.assigned_by_name} <${props.enrollment.assigned_by_email}>`}
    />
    <PasswordForm />
  </EditModal></FormProvider>)
}
